export default "__VITE_ASSET__BDWBCm1P__"